import { gql } from '@apollo/client'

export const GET_PLATFORMS = gql`
  query Platforms($activeOnly: Boolean) {
    platforms(activeOnly: $activeOnly) {
      slug
      displayName
      sortOrder
      active
    }
  }
`
